// extracted by mini-css-extract-plugin
export default {"home":"Home_home__PqZOu","homeContent":"Home_homeContent__AxBgr","carouselContainer":"Home_carouselContainer__c0RZj"};